<template>
	<nav class="news-sidebar" :class="{ 'news-sidebar--open': isOpen }" :data-topbar-visible="isTopBarVisible" aria-label="Kategorie postów">
		<button type="button" class="news-sidebar__toggle" :aria-expanded="isOpen" @click="isOpen = !isOpen">
			<span>{{ activeCategoryLabel }}</span>
			<GlobalIcon name="arrow-down" :height="14" class="news-sidebar__toggle-icon" :class="{ 'news-sidebar__toggle-icon--active': isOpen }" />
		</button>
		<ul class="news-sidebar__list">
			<li>
				<NuxtLink
					:to="localePath('blog')"
					class="news-sidebar__link"
					:class="{ 'news-sidebar__link--active': !activeCategorySlug }"
					@click="isOpen = false">
					{{ $t('pages.news.all_categories') }}
				</NuxtLink>
			</li>
			<li v-for="category in categories" :key="category.id">
				<NuxtLink
					:to="categoryLink(category)"
					class="news-sidebar__link"
					:class="{ 'news-sidebar__link--active': isActiveCategory(category) }"
					@click="isOpen = false">
					{{ category.name }}
				</NuxtLink>
			</li>
		</ul>
	</nav>
</template>

<script setup lang="ts">
const $t = useI18n().t
const localePath = useLocalePath()
const i18nService = usei18nService()
const localeLang = i18nService.getLocaleLang()
const newsStore = useNewsStore()
const isTopBarVisible = useIsTopBarVisible()

const pageContext = newsStore.state.pageContext
const activeCategorySlug = computed(() => (pageContext?.type === 'category' ? pageContext.categorySlug : null))

const isOpen = ref(false)
const categories = ref<INewsCategoryModel[]>([])

try {
	categories.value = await ApiService.fetchNewsCategories(localeLang)
} catch (error) {
	logger.log(error)
}

const isActiveCategory = (category: INewsCategoryModel) => activeCategorySlug.value === category.slug
const categoryLink = (category: INewsCategoryModel) => localePath({ name: 'blog-newsTitle', params: { newsTitle: [category.slug] } })

const activeCategoryLabel = computed(() => {
	const active = categories.value.find(isActiveCategory)
	return active ? active.name : $t('pages.news.all_categories')
})
</script>

<style lang="scss" scoped src="./Sidebar.scss"></style>
